"use client";

/**
 * Client source of truth for the live Recommended category.
 * RecommendedItemsCategory publishes the category derived from the menu it
 * renders; NavigationBar consumes the same value so both update together.
 */
import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from "react";
import { Category } from "@/dto/category";

interface RecommendedCategoryContextType {
  recommendedCategory: Category | null;
  setRecommendedCategory: Dispatch<SetStateAction<Category | null>>;
}

const RecommendedCategoryContext =
  createContext<RecommendedCategoryContextType>({
    recommendedCategory: null,
    setRecommendedCategory: () => {},
  });

export const RecommendedCategoryProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [recommendedCategory, setRecommendedCategory] =
    useState<Category | null>(null);

  const value = useMemo(
    () => ({ recommendedCategory, setRecommendedCategory }),
    [recommendedCategory]
  );

  return (
    <RecommendedCategoryContext.Provider value={value}>
      {children}
    </RecommendedCategoryContext.Provider>
  );
};

export const useRecommendedCategory = () =>
  useContext(RecommendedCategoryContext);
